const SvgSearch = () => {
  return (
    <svg
      width="3rem"
      height="3rem"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.17143 0C10.3386 0 12.4171 0.860916 13.9495 2.39336C15.4819 3.9258 16.3429 6.00423 16.3429 8.17143C16.3429 10.1954 15.6011 12.056 14.3817 13.4891L14.7211 13.8286H15.7143L22 20.1143L20.1143 22L13.8286 15.7143V14.7211L13.4891 14.3817C12.056 15.6011 10.1954 16.3429 8.17143 16.3429C6.00423 16.3429 3.9258 15.4819 2.39336 13.9495C0.860916 12.4171 0 10.3386 0 8.17143C0 6.00423 0.860916 3.9258 2.39336 2.39336C3.9258 0.860916 6.00423 0 8.17143 0ZM8.17143 2.51429C5.02857 2.51429 2.51429 5.02857 2.51429 8.17143C2.51429 11.3143 5.02857 13.8286 8.17143 13.8286C11.3143 13.8286 13.8286 11.3143 13.8286 8.17143C13.8286 5.02857 11.3143 2.51429 8.17143 2.51429Z"
        fill="#fff"
      />
    </svg>
  );
};

export default SvgSearch;
